import React from "react";

import "./ChartTooltip.css";

interface ChartProps {
	style?: React.CSSProperties;
}

export const ChartTooltip: React.FunctionComponent<
	React.PropsWithChildren<ChartProps>
> = ({ style, children }) => (
	<div className="chart-tooltip" style={style}>
		{children}
	</div>
);

export const ChartTooltipLabel: React.FunctionComponent<
	React.PropsWithChildren<ChartProps>
> = ({ style, children }) => (
	<div className="chart-tooltip__label" style={style}>
		{children}
	</div>
);

export const ChartTooltipValue: React.FunctionComponent<
	React.PropsWithChildren<ChartProps>
> = ({ style, children }) => (
	<div className="chart-tooltip__value" style={style}>
		{children}
	</div>
);
